class LabelAddingClass {
    constructor(inputBtn, wrapper) {
        this.inputBtn = inputBtn;
        this.wrapper = wrapper;
    }
    switchCheckedClass(e) {
        const listItem = e.currentTarget.parentNode.parentNode;
        const wrap = listItem.parentNode;
        let inputBtn = wrap.querySelectorAll(this.inputBtn);
        const currentLabel = e.currentTarget.parentNode;

        if (inputBtn) {
            inputBtn = Array.prototype.slice.call(inputBtn);
            if (e.currentTarget.type === "checkbox") {
                if (currentLabel.classList.contains('is-checked')) {
                    currentLabel.classList.remove('is-checked');
                }
                else {
                    currentLabel.classList.add('is-checked');
                    currentLabel.querySelectorAll(this.inputBtn)[0].checked = true;
                }
            }
            else {
                inputBtn.forEach(element => {
                    const label = element.parentNode;
                    if (label.classList.contains('is-checked')) {
                        label.classList.remove('is-checked');
                    }
                    currentLabel.classList.add('is-checked');
                    currentLabel.querySelectorAll(this.inputBtn)[0].checked = true;
                });
            }





        }


    }
    init() {

        let wpcf7Radios = document.querySelectorAll(this.wrapper);
        if (wpcf7Radios) {
            wpcf7Radios = Array.prototype.slice.call(wpcf7Radios);
            wpcf7Radios.forEach(wpcf7Radio => {
                let inputBtn = wpcf7Radio.querySelectorAll(this.inputBtn);
                if (inputBtn) {
                    inputBtn = Array.prototype.slice.call(inputBtn);
                    inputBtn.forEach((element, index) => {
                        if (index === 0) {
                            const label = element.parentNode;
                            label.classList.add('is-checked');
                            label.querySelectorAll(this.inputBtn)[0].checked = true;
                        }
                        element.addEventListener('change', e => {
                            this.switchCheckedClass(e);
                        });
                    })
                }
            });
        }
    }
}

const classOnRadio = new LabelAddingClass('input[type="radio"]', '.wpcf7-radio');
const classOnCheckbox = new LabelAddingClass('input[type="checkbox"]', '.wpcf7-checkbox');

export default classOnRadio;
export { classOnCheckbox }